import React, {useEffect, useState, useRef, useLayoutEffect, useMemo} from "react";
import SmartMap from './GoogleMap';
import {calculateDistance, ensure_slug} from '../utils';
import useUserInfoContext from "../contexts/UserInfoContext";
import {MapSidebar, TypeFilter} from "./MapSidebar";
import { MapDataProvider } from "../contexts/MapDataContext";
import useGeoLocation from '../../hooks/useGeoLocation';


const configureData = (markers, options, userLocation, exclude_types) => {
	let sortedMarkers = markers;
	let markerTypes = [];
	let types = {}
	sortedMarkers.map((marker) => {
		if (userLocation.loaded) {
			marker.distance = calculateDistance(userLocation.coords, marker);
		}
		if (!markerTypes.includes(marker.type)) {
			markerTypes.push(marker.type);
			types[marker.type] = exclude_types.includes(marker.type) ? false : true;
		}
	})

	const stations = sortedMarkers.filter((marker) => marker.type == "gjenvinningsstasjoner");
	const units = sortedMarkers.filter((marker) => marker.type !== "gjenvinningsstasjoner");
	if (userLocation.loaded) {
		stations.sort((a, b) => {return userLocation.coords ? a.distance - b.distance : a.title.localeCompare(b.title)})
		units.sort((a, b) => {return userLocation.coords ? a.distance - b.distance : a.title.localeCompare(b.title)})
	} else {
		stations.sort((a, b) => {return a.title.localeCompare(b.title)});
		units.sort((a, b) => {return a.title.localeCompare(b.title)});
	}

	const optionsArray = [];
	options.map((filter) => {
		optionsArray.push({value: filter.value, label: filter.label});
	});

	return {filters: options, markers: stations.concat(units), types: types};
}

const MapComponent = (props) => {
	const {userLocation, askForUserLocation, activeMunicipality} = useUserInfoContext();
	const [data, setData] = useState(() => configureData(props.map, props.filters, userLocation, props.exclude_types));
	const [currentFilter, setCurrentFilter] = useState({"municipality": activeMunicipality.name, "types": data?.types})
	const [activeId, setActiveId] = useState(null);

	const defaultData = useMemo(()=> {
		const _data = configureData(props.map, props.filters, userLocation, props.exclude_types)
		return _data;
	}, []);


	if ((new Date().getTime() / 1000) > userLocation?.timestamp + 10000) {
		askForUserLocation();
	}

	const UpdateActiveMarkerId = (id) => {
		setActiveId(id);
	}

	const updateMarkerVisibility = (key, value) => {
		const deliveryLocationList = document.getElementById('deliveryLocations');
		if (deliveryLocationList.style.paddingBottom != '0%') {
			deliveryLocationList.style.paddingBottom = '0%';
		}

		setActiveId(null);
		if (key === 'reset' && value === 'reset') {
			setCurrentFilter({
					"municipality": activeMunicipality.name,
					"types": defaultData.types
			});
		} else {
			setCurrentFilter(current => {
				return {...current, [key]: value}
			});
		}
	}

	return (
		<MapDataProvider filterOptions={data?.filters} sortedMarkers={data?.markers} currentFilter={activeMunicipality.name}>
			<MapSidebar currentFilter={currentFilter} updateMarkerVisibility={updateMarkerVisibility} updateActiveMarkerId={UpdateActiveMarkerId} markers={data?.markers}  />
			<div className="smart-map__map" data-location={userLocation ? 'loaded' : 'fetching'}>
				<TypeFilter types={data?.types} currentFilter={currentFilter} updateMarkerVisibility={updateMarkerVisibility} />
				<SmartMap markers={data?.markers} activeId={activeId} currentFilter={currentFilter} />
			</div>
		</MapDataProvider>
	)
}


export default MapComponent;
